// Refrain from using `connected-react-router` for routing
// This can cause location (url) sync issues when dispatched
// Within an app using `BrowserRouter`
// See https://github.com/loomhq/loom/pull/11727#issuecomment-1016591478
import { push } from 'connected-react-router';

export function appendAndGotoUrlCreator(name) {
  return (dispatch, getState) => {
    const { pathname } = getState().router.location;

    let pathToAdd = encodeURIComponent(name);

    // add slash if pathname does not include it
    if (pathname.slice(-1) !== '/') {
      pathToAdd = `/${pathToAdd}`;
    }

    const newPathName = `${pathname}${pathToAdd}`;

    dispatch(push(newPathName));
  };
}
